const Diamond = () => (
  <span className="mx-6 inline-block h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
);

export default function Marquee({ items }) {
  return (
    <div className="marquee-paused relative overflow-hidden border-y border-gold/20 bg-black/50 py-5">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="font-accent text-sm font-medium uppercase tracking-[0.3em] text-amber-100/90 sm:text-base">
                  {item}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
